import React, { useState, useEffect, useRef } from "react";
import { auctionsLive, auctionsLiveDeclarator } from "../../Model/Auction";
import { getUser } from "../../Model/LocalStorage";
import GridLayout from "./gridLayout";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { R, FONT } from "./components/roomTheme";
import Leonlogo from "../assets/image/Logo.png";
import { GetURL, hostname } from "../../../config";
import { RoomMessage } from "./components/RoomSections";
import "./legacy-global.css";

/*
 * /auctions/room — entry point. Opens the socket, loads the live auction and joins its room.
 *
 * UNCHANGED: the socket connection (hostname(token)), the "connect" / "reconnect" handlers,
 * "ConnectedUser" and "joint_room" emits, the online / offline reconnect, LiveAuction()
 * (auctionsLive / auctionsLiveDeclarator) and the device-type request.
 */

function View(props) {
  const [socket, setSocket] = useState(null); // <-- for dynamic socket
  const navigate = useNavigate();



  const [loading, setLoading] = useState(false);
  const [getData, setGetData] = useState([]);
  const [room, setRoom] = useState("");
  const [, setMessage] = useState("");
const [group, setGroup] = useState("");
  const [, setStatus] = useState(0);
  const [, setUserID] = useState("");
  const [type, setType] = useState("");
  const [username, setUsername] = useState("");

  const [, setOnline] = useState(true);
  const hasRunLiveAuction = useRef(false);
  const updateNetworkStatus = () => setOnline(navigator.onLine);
  
  
// eto yung backup socket
const socketRef = useRef(null);

useEffect(() => {
  let isMounted = true;

  const connectSocket = async () => {
    const token = localStorage.getItem("token");
    const user = await getUser();
    let guestId = localStorage.getItem("guest_id") || `guest-${Math.random().toString(36).substring(2, 10)}`;
    if (!localStorage.getItem("guest_id")) localStorage.setItem("guest_id", guestId);
    
    const guestEmail = `guest00${Math.floor(Math.random() * 100000)}@user.com`;

    const newSocket = hostname(token);
    socketRef.current = newSocket;
    setSocket(newSocket);

    // 1. EVENT: KAPAG NAG-CONNECT O RECONNECT
    newSocket.on("connect", () => {
      if (!isMounted) return;
      console.log("✅ Socket connected:", newSocket.id);
      
      // Re-identify user
      newSocket.emit("ConnectedUser", {
        userId: user?.id || guestId,
        email: user?.email || guestEmail,
        group: user?.group || "BIDDER",
      });

      // 🔥 ITO ANG PINAKA-IMPORTANTE: 
      // Re-join the room automatically using the latest room state
      if (room) {
        newSocket.emit("joint_room", room);
        console.log("🏠 Re-joined room:", room);
      }
    });

    // 2. EVENT: RECONNECT (Success after being disconnected)
    newSocket.on("reconnect", (attempt) => {
      console.log(`🔄 Reconnected after ${attempt} attempts. Syncing data...`);
      // Force sync ng auction data mula sa API pagbalik ng socket
      LiveAuction(user?.group || "BIDDER", newSocket);
    });

    return () => {
      newSocket.disconnect();
      if (socketRef.current === newSocket) socketRef.current = null;
      setSocket(null);
    };
  };

  connectSocket();

  // 3. FORCE RECONNECT SA INTERNET STATUS
  const handleOnline = () => {
    setOnline(true);
    if (socketRef.current && socketRef.current.disconnected) {
      console.log("🔌 Internet back, forcing socket connect...");
      socketRef.current.connect();
    }
  };

  window.addEventListener("online", handleOnline);
  window.addEventListener("offline", updateNetworkStatus);

  return () => {
    isMounted = false;
    window.removeEventListener("online", handleOnline);
    window.removeEventListener("offline", updateNetworkStatus);
  };
}, [room]); // 👈 Nilagay natin ang 'room' dito para ma-update ang socket handler pag nakuha na ang Auction ID





  // This effect waits for the socket to be ready, then calls LiveAuction exactly once
  useEffect(() => {
    if (!socket || hasRunLiveAuction.current) return;
  
    hasRunLiveAuction.current = true;
  
    (async () => {
      try {
        const user = await getUser();
  
        if (!user) {
          // Guest
          LiveAuction("BIDDER", socket);
          return;
        }
  
        // Logged-in user
        LiveAuction(user.group, socket);
        setUserID(user.id);
        setGroup(user.group);
        setUsername(user.email);
      } catch (error) {
        console.error("Error in getUser or LiveAuction:", error);
      }
    })();
  }, [socket]);
  

  const LiveAuction = (group, socketInstance) => {
    setLoading(true);
    const fetchAuction = async () => {
      try {
        const results = group === "ADMIN" ? await auctionsLiveDeclarator() : await auctionsLive();
// console.log("LiveAuction ",results)
        if (!results.success) {
          setGetData([]);
          setMessage(results.msg || "No auction event found.");
          setOnline(false);

        } else {
          const auctionDetails = results.auction_details;
          setStatus(auctionDetails.isLive);
          setGetData(results);
          setRoom(auctionDetails.auction_id);

          

          socketInstance.emit("joint_room", auctionDetails.auction_id);
        }
      } catch (error) {
        console.error("LiveAuction error:", error);
        setMessage("Something went wrong.");
      } finally {
        setLoading(false);
      }
    };

    fetchAuction();

    /// pang get ng mga device
    fetch(`${GetURL}/type`)
      .then((res) => res.json())
      .then((data) => setType(data.isMobile))
      .catch((err) => console.log("Error getting type:", err));
  };

  if (loading) {
    return (
      <AuctionRoomShell
  username={username}
  auctionName={getData?.auction_details?.auction_name}
  group={group}
  onExit={() => navigate("/auctions")}
  onAuctioneer={() => navigate("/declarator/room")}
>
        <RoomMessage loading />
      </AuctionRoomShell>
    );
  }

  if (getData.length === 0) {
    return (
      <AuctionRoomShell
  username={username}
  auctionName={getData?.auction_details?.auction_name}
  group={group}
  onExit={() => navigate("/auctions")}
  onAuctioneer={() => navigate("/declarator/room")}
>
        <RoomMessage text="There are no auction events at the moment. Please stay tuned for future updates." />
      </AuctionRoomShell>
    );
  }

  return (
    <AuctionRoomShell
  username={username}
  auctionName={getData?.auction_details?.auction_name}
  group={group}
  onExit={() => navigate("/auctions")}
  onAuctioneer={() => navigate("/declarator/room")}
>
      <GridLayout
        LiveData={getData}
        Socket={socket}
        Type={type}
        mediadQuery={props.mediadQuery}
      />
    </AuctionRoomShell>
  );
}
function AuctionRoomShell({
  username,
  auctionName,
  group,
  onExit,
  onAuctioneer,
  children,
}) {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100dvh",
        minHeight: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        bgcolor: R.paper,
      }}
    >
      <Box
        component="header"
        sx={{
          flex: "0 0 auto",
          height: { xs: 90, sm: 56, md: 60 },
          minHeight: { xs: 90, sm: 56, md: 60 },
          display: "grid",
          gridTemplateColumns: { xs: "minmax(0, 1fr) auto", sm: "minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr)" },
          gridTemplateRows: { xs: "52px 38px", sm: "1fr" },
          alignItems: "center",
          gap: { xs: 0.75, sm: 1.5 },
          px: { xs: 1, sm: 2, md: 2.5 },
          bgcolor: R.paper,
          borderBottom: `1px solid ${R.lineStrong}`,
          boxSizing: "border-box",
          fontFamily: FONT,
          zIndex: 20,
        }}
      >
        <Box sx={{ minWidth: 0, display: "flex", alignItems: "center", gap: { xs: 0.75, sm: 1.25 }, gridColumn: { xs: "1", sm: "1" }, gridRow: { xs: "1", sm: "1" } }}>
          <Box
            component="img"
            src={Leonlogo}
            alt="Leon Gallery"
            sx={{ width: { xs: 82, sm: 105, md: 120 }, height: "auto", display: "block", flexShrink: 0 }}
          />
          <Typography
            component="span"
            sx={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontFamily: FONT,
              fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem" },
              color: R.secondary,
              display: { xs: "none", sm: "inline" },
            }}
          >
            Welcome <Box component="span" sx={{ color: R.ink, fontWeight: 700 }}>{username || "Guest"}</Box>
          </Typography>
        </Box>

        <Typography
          component="h1"
          title={auctionName || "Auction Room"}
          sx={{
            minWidth: 0,
            m: 0,
            px: 1,
            gridColumn: { xs: "1 / -1", sm: "2" },
            gridRow: { xs: "2", sm: "1" },
            textAlign: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontFamily: FONT,
            fontSize: { xs: "0.82rem", sm: "1rem", md: "1.08rem" },
            fontWeight: 700,
            color: R.ink,
          }}
        >
          {auctionName || "Auction Room"}
        </Typography>
<Box
  sx={{
    minWidth: 0,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: { xs: 0.5, sm: 1 },
    gridColumn: { xs: "2", sm: "3" },
    gridRow: { xs: "1", sm: "1" },
  }}
>
  {group === "ADMIN" ? (
  <Button
    type="button"
    onClick={onAuctioneer}
    variant="outlined"
    sx={{
      minWidth: { xs: 72, sm: 86, md: 96 },
      minHeight: { xs: 32, sm: 36 },
      px: { xs: 1, sm: 1.5 },
      borderRadius: 0,
      borderColor: R.ink,
      color: R.ink,
      fontFamily: FONT,
      fontSize: { xs: "0.55rem", sm: "0.65rem" },
      fontWeight: 700,
      letterSpacing: { xs: "0.4px", sm: "0.8px" },
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      "&:hover": {
        borderColor: R.ink,
        bgcolor: R.ink,
        color: R.paper,
      },
    }}
  >
    Auctioneer
  </Button>
) : null}

  <Button
    type="button"
    onClick={onExit}
    variant="outlined"
    sx={{
      minWidth: { xs: 58, sm: 72, md: 82 },
      minHeight: { xs: 32, sm: 36 },
      px: { xs: 1, sm: 1.5 },
      borderRadius: 0,
      borderColor: R.ink,
      color: R.ink,
      fontFamily: FONT,
      fontSize: { xs: "0.62rem", sm: "0.7rem" },
      fontWeight: 700,
      letterSpacing: { xs: "0.5px", sm: "1px" },
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      "&:hover": {
        borderColor: R.ink,
        bgcolor: R.ink,
        color: R.paper,
      },
    }}
  >
    Exit Room
  </Button>
</Box>
      </Box>

      <Box sx={{ flex: "1 1 auto", minHeight: 0, overflow: "hidden" }}>
        {children}
      </Box>
    </Box>
  );
}

export default View;
